import type { BorrowMarketDetail, BorrowMarketPair } from '@/utils/internalAppSdk'
import { getBorrowMarketCollateralAsset } from './getBorrowMarketCollateralAsset'

export const isBorrowMarketCollateralPairSearchMatch = ({
  market,
  pair,
  search,
}: {
  market: BorrowMarketDetail
  pair: BorrowMarketPair
  search: string
}) => {
  const normalizedSearch = search.trim().toLowerCase()
  if (!normalizedSearch) return true

  const collateralAsset = getBorrowMarketCollateralAsset(market, pair)
  const searchableText = [
    collateralAsset?.asset.symbol,
    collateralAsset?.asset.name,
    collateralAsset?.asset.address,
    collateralAsset?.marketAssetId,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

  return searchableText.includes(normalizedSearch)
}
